import { render, staticRenderFns } from "./alarms-grid.vue?vue&type=template&id=50be08da&scoped=true&"
import script from "./alarms-grid.ts?vue&type=script&lang=ts&"
export * from "./alarms-grid.ts?vue&type=script&lang=ts&"
import style0 from "./alarms-grid.scss?vue&type=style&index=0&id=50be08da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50be08da",
  null
  
)

export default component.exports